import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setNewBookingStartDate } from '../actions/newBooking';
import { setError } from '../actions/environment';

import DaySelector from '../components/Create/DaySelector';

class DaySelectorContainer extends Component {
    componentDidMount() {
        const { validDriversLicense } = this.props;

        // Make sure that we don't show the message when we reload
        if (validDriversLicense !== null && !validDriversLicense) {
            this.props.setError([`Your drivers license details are invalid, please visit the desktop Pool Booking website to update them.`]);
        }
    }

    render() {
        return (
            <DaySelector
                selectedDate={this.props.selectedDate}
                setDate={this.props.setDate}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const { startTime } = state.newBooking;
    const { person } = state.environment;

    return {
        selectedDate: startTime,
        validDriversLicense: person.permissions !== undefined ? person.permissions.hasValidDriversLicence : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setDate: setNewBookingStartDate,
        setError,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DaySelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/DaySelectorContainer.jsx